import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {FileInfo} from "../../models/treaty.models";
import {of, Subject} from "rxjs";
import {FileManagementService} from "@core/services/file-management.service";
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import {SnackBarService} from "@core/services/snack-bar.service";
import {takeUntil} from "rxjs/operators";
import {DoNothingAction} from "@shared/store/actions/particle.actions";
import {QueryProvider} from "@shared/queries/query-provider";
import {select, Store} from "@ngrx/store";
import {IQueryState} from "@shared/store/reducers/query.reducer";
import {getQueryResponse} from "@shared/store/selectors/query.selector";
import {BreadcrumbModel} from "@shared/models/breadcrumb.model";
import {TreatyApiService} from "../../services/treaty.service";

@Component({
    standalone: false,
    selector: 'particle-treaty-pdf-viewer',
  templateUrl: './treaty-pdf-viewer.component.html',
  styleUrls: ['./treaty-pdf-viewer.component.scss']
})
export class TreatyPdfViewerComponent implements OnInit {
  @Input() fileInfo: FileInfo;
  stream:any;
  pdfId:string;
  private unsubscribe$ = new Subject<void>();

  constructor(protected activatedRoute: ActivatedRoute,
              private fileManagementService:FileManagementService,
              private snackBarService: SnackBarService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private queryState: Store<IQueryState>,
              private treatyService: TreatyApiService) {
  }

  ngOnInit() {
    this.pdfId = this.fileInfo.id;
    if(this.fileInfo.id) {
      this.treatyService.getEmbeddedFileUrl(this.fileInfo.id).subscribe(response => {
        this.stream = response.downloadUrl;
      })
    }
  }

  ngOnDestroy () {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }


  downloadPdf(file: Blob) {
    this.fileManagementService.openSaveFileWindow(file,this.fileInfo.title );
  }

}
